<p-card>
    <div *ngIf="contact" class="flex justify-center flex-wrap flex-col">
        <!-- flip animation -->
        <div class="flex justify-center animate-flipleft">
            <img
                src="assets/img/default-user.jpg?preset=medium"
                class="rounded-circle mt-2 contact-card-profile-image"
                alt="contact image"
            />
        </div>
        <!-- Firstname / Lastname -->
        <div class="flex justify-center mt-2 text-xl">
            <span
                >{{ contact.title?.identifier }} {{ contact.firstName }}
                {{ contact.lastName }}</span
            >
        </div>
        <!-- addition -->
        <div *ngIf="contact.addition" class="flex justify-center">
            <span class="text-slate-400">{{ contact.addition }}</span>
        </div>

        <!-- just some space -->
        <div class="mt-2"></div>

        <!-- location -->
        <div class="flex justify-center mt-2">
            <!-- TODO postal address -->
            <span><i class="fa-solid fa-map-marker-alt"></i> Deutschland</span>
        </div>
        <!-- email -->
        <div *ngIf="contact.defaultEmail" class="flex justify-center mt-2">
            <a [href]="contact.defaultEmail | mailToLink" class="card-link">
                <i class="fa-solid fa-envelope"></i>&nbsp;
                <span class="normalText">{{ contact.defaultEmail }}</span>
            </a>
        </div>
        <!-- phone -->
        <div *ngIf="contact.mainPhone" class="flex justify-center mt-2">
            <a [href]="'tel: ' + contact.mainPhone" class="card-subtitle text-body-secondary">
                <i class="fa-solid fa-phone"></i>&nbsp;
                <span class="normalText">{{ contact.mainPhone | phone }}</span>
            </a>
        </div>
        <!-- mobile -->
        <div *ngIf="contact.mobilePhone" class="flex justify-center mt-2">
            <a [href]="'tel: ' + contact.mobilePhone" class="card-subtitle text-body-secondary">
                <i class="fa-solid fa-mobile-screen-button"></i>&nbsp;
                <span class="normalText">{{ contact.mobilePhone | phone }}</span>
            </a>
        </div>
        <!-- important information -->
        <div *ngIf="contact.notes" class="flex justify-center mt-6">
            <!-- pre-wrap to display new lines -->
            <span
                [ngStyle]="{ 'white-space': 'pre-wrap' }"
                class="text-slate-400"
                pTooltip="{{ 'common.notes' | translate }}"
                >{{ contact.notes }}</span
            >
        </div>
    </div>
</p-card>
